import { axios } from '@/axios';
import { config } from '@/config';
import { parseQueryString } from '@/util';

class LtiService {
  constructor({ courseId, userId, progressStep = 0.01 }) {
    LtiService._instance = this;

    this.queries = parseQueryString(document.location.search);
    this.courseId = courseId;
    this.userId = userId;
    this.step = progressStep;
    this.lastProgress = -1;
  }

  /** Singleton accessor */
  static getInstance(opts) {
    if (!LtiService._instance) {
      new LtiService(opts); // Create a new instance if none exists
    }
    return LtiService._instance; // Return the singleton instance
  }

  /** Is LTI context active?  (looks for ?lti=true in query string) */
  available() {
    return this?.queries?.lti === 'true';
  }

  /** Send progress update if it changed enough */
  async progress(progress) {
    if (Math.abs(progress - this.lastProgress) < this.step) return;
    this.lastProgress = progress;
    await this._callBackend();
  }

  /** Call once when the course is finished */
  async reportFinal() {
    await this._callBackend();
  }

  /** Actually hits your BE; server decides status / score */
  async _callBackend() {
    try {
      await axios.post(
        `${config.backend}/api/lti/report-score`,
        { courseId: this.courseId, userId: this.userId },
        { withCredentials: true }
      );
    } catch (e) {
      console.error('Failed to report LTI progress/score', e);
    }
  }
}

export { LtiService };
